module.exports = __webpack_public_path__ + "img/public/SiteIcons/outerStar.svg?fa6e1eda";